import { render, staticRenderFns } from "./AppAside.vue?vue&type=template&id=0b507879"
import script from "./AppAside.vue?vue&type=script&lang=js"
export * from "./AppAside.vue?vue&type=script&lang=js"
import style0 from "./AppAside.vue?vue&type=style&index=0&id=0b507879&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports